var map = {
	"./media_m_1.png": 7482,
	"./media_m_2.png": 6465,
	"./media_m_3.png": 8200,
	"./media_m_4.png": 3367,
	"./media_m_chat.png": 8833,
	"./media_m_work.png": 260,
	"./media_pc_1.png": 736,
	"./media_pc_2.png": 6139,
	"./media_pc_3.png": 2482,
	"./media_pc_4.png": 5277,
	"./media_pc_chat.png": 1783,
	"./media_pc_monitor.png": 3127,
	"./media_pc_work.png": 8158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1858;